/** Session handoff from PvP lobby → `/pvp-quiz/:segment` so refresh keeps working; bookmarks expire. */

const STORAGE_KEY = 'pvp_quiz_session';
const SESSION_MS = 4 * 60 * 60 * 1000; // 4h

function normalizeSegment(segment: string): string {
  return segment.trim().toLowerCase();
}

export function markPvpQuizEntryFromLobby(roomUrlSegment: string): void {
  const seg = normalizeSegment(roomUrlSegment);
  if (!seg) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ seg, exp: Date.now() + SESSION_MS })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function isPvpQuizSessionValidForRoom(roomUrlSegment: string): boolean {
  const seg = normalizeSegment(roomUrlSegment);
  if (!seg) return false;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { seg: string; exp: number };
    if (typeof parsed.exp === 'number' && Date.now() > parsed.exp) {
      sessionStorage.removeItem(STORAGE_KEY);
      return false;
    }
    return normalizeSegment(parsed.seg) === seg;
  } catch {
    return false;
  }
}
